import React from 'react';
import moment from 'moment';
import { DATE_TIME_FORMAT } from '../../constants';
import EditLeaseImei from './EditLeaseImei';

const LeaseList = ({ leases = [], showCloseLease, handleUpdateField }) => (
  <div>
    <table className="table">
      <thead>
        <tr>
          <th>ID</th>
          <th>Lease Type</th>
          <th>Status</th>
          <th>Description</th>
          <th>Monthly</th>
          <th>Imei</th>
          <th>Date Created</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {leases.length > 0 &&
          leases.map((lease) => (
            <tr key={lease.id}>
              <td>{lease.id}</td>
              <td>{lease.lease_type}</td>
              <td>{lease.status}</td>
              <td>{lease.description}</td>
              <td>{lease.monthly}</td>
              {lease.status === 'closed' ? (
                <td>{lease.imei}</td>
              ) : (
                <EditLeaseImei
                  id={lease.id}
                  save={handleUpdateField}
                  name="imei"
                  value={lease.imei}
                />
              )}
              <td>
                {lease.date_created
                  ? moment(lease.date_created).format(DATE_TIME_FORMAT)
                  : ''}
              </td>
              <td>
                {lease.status !== 'closed' && (
                  <button
                    className="btn btn-default"
                    onClick={() => showCloseLease(lease.id)}
                  >
                    Close
                  </button>
                )}
              </td>
            </tr>
          ))}
        {leases.length === 0 ? (
          <tr>
            <td colSpan="6">No leases yet</td>
          </tr>
        ) : null}
      </tbody>
    </table>
  </div>
);

export default LeaseList;
